































import Layout from '@/layout/common/index.vue'
import HeaderTools from '@/layout/mkt-layout/header-tools.vue'
import Sidebar from '@/layout/mkt-layout/sidebar/index.vue'
import { defineComponent, PropType, reactive } from '@vue/composition-api'
import { UserInfoState } from '@/layout/types'
import { useEmitterEvent } from '@/use'
import { useWindowEvent } from '@/use'
import SystemLoading from '@/components/system-loading.vue'
import { mergedForceHideMenuMap } from '@/layout/mkt-layout/force-hide-menu-url'
import { isSameUrlPath } from '@/utils'

const handleMountPublishButton = (el: Element) => {
  const publishContainer = document.querySelector('.mkt-publish-warp') as Element
  // empty searchContainer
  while (publishContainer.firstChild) {
    publishContainer.removeChild(publishContainer.firstChild)
  }
  publishContainer.appendChild(el)
}

const useHideLayout = () => {
  const hideLayout = reactive({
    menu: false,
    header: false,
  })

  useEmitterEvent('force-hide-layout', ({ menu, header }: Record<string, boolean>) => {
    hideLayout.menu = menu
    hideLayout.header = header
  })

  useWindowEvent(
    'single-spa:before-routing-event',
    () => {
      hideLayout.header = mergedForceHideMenuMap.forceHideHeader.some((item) => isSameUrlPath(item))
      hideLayout.menu = mergedForceHideMenuMap.forceHideMenu.some((item) => isSameUrlPath(item))
    },
    {
      immediate: true,
    },
  )

  return hideLayout
}

export default defineComponent({
  name: 'MKTLayout',
  components: {
    Layout,
    HeaderTools,
    SystemLoading,
    Sidebar,
  },
  props: {
    loading: Boolean,
    userInfoState: {
      required: true,
      type: Object as PropType<UserInfoState>,
    },
  },
  setup(props) {
    useEmitterEvent('mount-publish-button', handleMountPublishButton)

    const hideLayout = useHideLayout()

    return {
      hideLayout,
    }
  },
})
